const emitterProps = {
  cart: {
    get: 'cart.get',
    add: 'cart.add',
    update: 'cart.update',
    clear: 'cart.clear',
    count: 'cart.count',
    change: 'cart.change',
    render: 'cart.render',
    trigger: 'cart.trigger'
  },
  product: {
    updateVariant: 'product.update_variant',
    productLinked: 'product.product_linked',
    hotSpot: 'product.hot_spot'
  },
  notice: {
    global: 'notice.global'
  },
  modal: {
    close: 'modal.close'
  },
  search: {
    closeDropdown: 'search.close_dropdown'
  }
}

class GlobalEmitter {
  emit (name, payload) {
    const event = new CustomEvent(name, {
      detail: payload
    })
    document.dispatchEvent(event)
  }

  on (name, callback) {
    document.addEventListener(name, (e) => {
      callback(e.detail)
    })
  }

  off (name, callback) {
    document.removeEventListener(name, callback)
  }
}

const globalEmitter = new GlobalEmitter()

export {
  emitterProps,
  globalEmitter
}
